var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Errors',{staticClass:"tw-p-2",attrs:{"errors":_vm.searchErrors}}),_vm._v(" "),_c('ProductAddToCartModal'),_vm._v(" "),_c('Results'),_vm._v(" "),_c('ComparePanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }